export default __webpack_public_path__ + "static/media/slime_merchant.2df7a091.png";